/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description: ESA colors palette

Author: Deimos Space UK

Version: 1.0
*/
export const ESA_COLORS = ['#003247', '#ed1b2f', '#009bdb', '#fbab18', '#00ae9d', '#e8e8e4', '#000000', '#8b4513', '#ff69b4', '#7cfc00', '#9400d3', '#ffa500', '#4169e1', '#4caf50', '#e91e63', '#ffc107', '#2196f3', '#9c27b0', '#ff5722', '#607d8b']